import { useEffect, useState } from "react";
import styled from "styled-components";
import { LoaderIcon } from "react-hot-toast";
import firebase from "../../shared/firebase";
import { getAuth, applyActionCode } from "firebase/auth";
import { useTranslation } from "../../lib/use-translation";

const Stage = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
`;

const Image = styled.img`
  height: 40px;
  margin: 0 auto;
  display: block;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;
const Box = styled.div`
  /* #222225 has no exact token match (not HOOPER_DARK_GRAY, not divider) and
  this card sits on VerifyView's fixed-dark background regardless of scheme
  — left as a literal rather than guessed. See phase2-report.md. */
  border: 1px solid #222225;
  border-radius: 8px;
  max-width: 400px;
  text-align: center;
  padding: 24px;
`;

export default function Verify() {
  const { t } = useTranslation("components/verify", "verify");
  const [verified, setVerified] = useState<boolean>();

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get("oobCode");
    if (!code) {
      setVerified(false);
    } else {
      const auth = getAuth(firebase);
      applyActionCode(auth, code)
        .then(() => setVerified(true))
        .catch(() => setVerified(false));
    }
  }, []);

  return (
    <Stage>
      <Card>
        <Image src="/images/logo-white.svg" alt="hooper" />
        <Box>
          {verified === null && (
            <LoaderIcon style={{ transform: "scale(1.5)" }} />
          )}
          {verified === false && (
            <p>
              {t(
                "invalid",
                "The verification link is invalid or has expired. Please try verifying your email address again.",
              )}
            </p>
          )}
          {verified === true && (
            <p>
              {t(
                "success",
                "Thank you for verifying your email address! You can close this browser tab.",
              )}
            </p>
          )}
        </Box>
      </Card>
    </Stage>
  );
}
